import { render, staticRenderFns } from "./MaintenancePolicyPage.vue?vue&type=template&id=73fe27e6&scoped=true&"
import script from "./MaintenancePolicyPage.vue?vue&type=script&lang=js&"
export * from "./MaintenancePolicyPage.vue?vue&type=script&lang=js&"
import style0 from "./MaintenancePolicyPage.vue?vue&type=style&index=0&id=73fe27e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fe27e6",
  null
  
)

export default component.exports